interface BadgeProps {
  variant: 'status' | 'role' | 'employmentType';
  children: string;
  square?: boolean;
}

const variantStyles = {
  status: {
    active: 'bg-green-100 text-green-700 border border-green-300',
    inactive: 'bg-gray-100 text-gray-600 border border-gray-300',
  },
  role: {
    user: 'bg-gray-100 text-gray-700 border border-gray-300',
    admin: 'bg-gray-100 text-gray-700 border border-gray-300',
  },
  employmentType: {
    employee: 'bg-blue-100 text-blue-700 border border-blue-300',
    contractor: 'bg-orange-100 text-orange-700 border border-orange-300',
  },
};

function getStyleClass(variant: string, value: string): string {
  switch (variant) {
    case 'status':
      return variantStyles.status[value as 'active' | 'inactive'] || variantStyles.status.active;

    case 'role':
      return variantStyles.role[value as 'user' | 'admin'] || variantStyles.role.user;

    case 'employmentType':
      return (
        variantStyles.employmentType[value as 'employee' | 'contractor'] ||
        variantStyles.employmentType.employee
      );

    default:
      return variantStyles.status.active;
  }
}

export function Badge({ variant, children, square = false }: BadgeProps) {
  const value = String(children).toLowerCase();
  const roundedClass = square ? 'rounded-none' : 'rounded-full';
  const displayText =
    variant === 'role' && value === 'user' ? 'STANDARD' : String(children).toUpperCase();

  if (square) {
    return (
      <div
        className={`inline-flex items-center justify-center rounded-none border px-3 py-1.5 text-xs font-bold tracking-wider uppercase ${getStyleClass(variant, value)}`}
      >
        {displayText}
      </div>
    );
  }

  return (
    <span
      className={`inline-flex items-center px-3 py-1.5 ${roundedClass} text-xs font-bold tracking-wider uppercase ${getStyleClass(variant, value)}`}
    >
      {displayText}
    </span>
  );
}
